import { apiClient } from "./client";

export async function testCloudConnection({ apiKey }) {
  const res = await apiClient.post("/dash/cloud/test", { apiKey });
  return res.data;
}

export async function saveCloudCredentials(id, { apiKey, organizationId }) {
  const res = await apiClient.post("/dash/cloud/save", { id, apiKey, organizationId });
  return res.data;
}

export async function clearCloudCredentials(id) {
  const res = await apiClient.post("/dash/cloud/clear", { id });
  return res.data;
}

export async function getCloudStatus(id) {
  const res = await apiClient.post("/dash/cloud/status", { id });
  return res.data;
}
